(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const nav = document.querySelector('[data-tpl-about-nav]');
    if (!nav) return;
    const links = nav.querySelectorAll('[data-about-nav]');
    const sections = [];

    /* Build section map */
    links.forEach(link => {
      const id = link.getAttribute('href').substring(1);
      const target = document.getElementById(id);
      if (target) sections.push({ id, el: target, link });
    });

    /* Smooth scroll on click */
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const id = link.getAttribute('href').substring(1);
        const target = document.getElementById(id);
        if (target) {
          const targetPos = target.getBoundingClientRect().top + window.scrollY - 16;
          window.scrollTo({ top: targetPos, behavior: 'smooth' });
        }
      });
    });

    /* Show nav only after scrolling past hero */
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const viewH = window.innerHeight;

        /* Show after scrolling past ~60% of the hero, hide near footer */
        var footer = document.querySelector('footer.footer');
        var hideNearFooter = false;
        if (footer) {
          var footerRect = footer.getBoundingClientRect();
          hideNearFooter = footerRect.top < viewH + 80;
        }
        nav.classList.toggle('is-visible', scrollY > viewH * 0.6 && !hideNearFooter);

        /* Active section detection */
        let activeId = null;
        const triggerPoint = window.innerWidth <= 749 ? 80 : viewH * 0.4;
        for (let i = sections.length - 1; i >= 0; i--) {
          const rect = sections[i].el.getBoundingClientRect();
          if (rect.top <= triggerPoint) {
            activeId = sections[i].id;
            break;
          }
        }

        links.forEach(link => {
          const id = link.getAttribute('href').substring(1);
          const isActive = id === activeId;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        /* Mobile: scroll active link into view */
        if (window.innerWidth <= 749 && activeId) {
          const activeLink = nav.querySelector('[data-about-nav].is-active');
          if (activeLink) {
            const track = nav.querySelector('.tpl-about-nav__track');
            const linkRect = activeLink.getBoundingClientRect();
            const trackRect = track.getBoundingClientRect();
            if (linkRect.left < trackRect.left || linkRect.right > trackRect.right) {
              activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          }
        }

        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
